// @core/api/endpoints/task/create_custom_field_definition.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateCustomFieldDefinitionRequest,
  CustomFieldDefinitionResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Create custom field
 * Creates a custom field definition (e.g., Severity, Story Points, Affected Version). Fields are defined per tenant, then referenced by task type or container config.
 */
export async function CreateCustomFieldDefinition(
  data: CreateCustomFieldDefinitionRequest,
  options?: RequestOptions
): Promise<CustomFieldDefinitionResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/custom-fields`;
  const requestOptions = options;
  return client.post<CustomFieldDefinitionResponse>(requestPath, data, requestOptions);
}
